/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Stripe_Publishable_KeyInputs */

const en_admin_settings_fields_stripe_publishable_key = /** @type {(inputs: Admin_Settings_Fields_Stripe_Publishable_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishable Key`)
};

/**
* | output |
* | --- |
* | "Publishable Key" |
*
* @param {Admin_Settings_Fields_Stripe_Publishable_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_stripe_publishable_key = /** @type {((inputs?: Admin_Settings_Fields_Stripe_Publishable_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Stripe_Publishable_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_stripe_publishable_key(inputs)
});
export { admin_settings_fields_stripe_publishable_key as "admin.settings.fields.stripe_publishable_key" }